import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

const byIds = ({
  ids,
  useQueryOptions,
}: {
  ids: MaybeRef<string[]>
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => useQuery({
  queryKey: ['youtube-videos', ids],
  queryFn: () => {
    const config = useRuntimeConfig()
    const url = 'https://youtube.googleapis.com/youtube/v3/videos'
    const queryParams = {
      part: 'snippet,contentDetails',
      id: String(unref(ids)),
      key: config.public.youtubeApiKey,
    }

    interface YouTubeVideoResponse {
      items: {
        id: string
        snippet: {
          title: string
          thumbnails: {
            high: {
              url: string
              width: number
              height: number
            }
          }
        }
        contentDetails: {
          duration: string
        }
      }[]
    }

    return $fetch<YouTubeVideoResponse>(url, { params: queryParams })
  },
  ...useQueryOptions,
})

export const useQueryYoutubeVideos = {
  byIds,
}
